import React from 'react';
import { CheckIcon } from 'lucide-react';
export function ResultsSection() {
  return <section className="py-6 px-4 bg-white" data-id="element-308">
      <div className="max-w-3xl mx-auto" data-id="element-309">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#5B3FA0]" data-id="element-310">
          EL RESULTADO PARA VOS COMO DOCENTE
        </h2>

        <p className="text-xl mb-4 font-medium text-center" data-id="element-311">
          Con este material vas a lograr:
        </p>

        <div className="bg-green-50 rounded-2xl p-5 border border-green-200 mb-4" data-id="element-312">
          <ul className="space-y-2 text-xl font-bold text-gray-800" data-id="element-313">
            <li className="flex items-start" data-id="element-314">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-315" />
              <span data-id="element-316">Ahorrar horas de planificación.</span>
            </li>
            <li className="flex items-start" data-id="element-317">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-318" />
              <span data-id="element-319">Tener los principales temas de ESI organizados.</span>
            </li>
            <li className="flex items-start" data-id="element-320">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-321" />
              <span data-id="element-322">Trabajar situaciones actuales con adolescentes.</span>
            </li>
            <li className="flex items-start" data-id="element-323">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-324" />
              <span data-id="element-325">Abordar temas sensibles con mayor seguridad.</span>
            </li>
            <li className="flex items-start" data-id="element-326">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-327" />
              <span data-id="element-328">Promover análisis, reflexión y pensamiento crítico.</span>
            </li>
          </ul>
        </div>

        <p className="text-2xl font-black text-center text-gray-900" data-id="element-329">
          <span className="px-2 bg-[#FFFFFF]" data-id="element-330">
            Todo sin perder tiempo buscando actividades en internet.
          </span>
        </p>
      </div>
    </section>;
}